import React from 'react'
import PropTypes from 'prop-types'
import DividerLib from '@material-ui/core/Divider'

function Divider({ light }) {
  return <DividerLib light={light} />
}

Divider.defaultProps = {
  light: false,
}

Divider.propTypes = {
  light: PropTypes.bool,
}

export default Divider
